/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_DueInputs */

const cs_enum_due = /** @type {(inputs: Enum_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Splatné`)
};

const en_enum_due = /** @type {(inputs: Enum_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due`)
};

/**
* | output |
* | --- |
* | "Due" |
*
* @param {Enum_DueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_due = /** @type {((inputs?: Enum_DueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_DueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_due(inputs)
	return cs_enum_due(inputs)
});